import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { up } from 'styled-breakpoints'
import styled, { useTheme } from 'styled-components'

import Button from '../../../../common/button'

import AppPage from '../../../../templates/app-page'
import AppStore from '../../../../common/app-store'

import { getBookByIsbn13 } from '../../../../../data/book/book'
import { Book } from '../../../../../data/book/data-types'
import { useAuth } from '../../../../../data/hooks/auth'
import { useHistory } from 'react-router-dom'
import Loader from '../../../../common/loader'
import BookInfo from '../../../../common/custom-dialogs/book/book-info'

const BookPage: React.FunctionComponent = () => {
    const { t } = useTranslation('book')
    const theme = useTheme()
    const { token } = useAuth()

    const location = useLocation()
    const history = useHistory()

    const params = new URLSearchParams(location.search)
    const isbn13 = params.get('isbn13') || ''

    const [book, setBook] = useState<Book|null>(null)
    const [pending, setPending] = useState(true)

    useEffect(() => {
        (async () => {
            try {
                setPending(true)
                const book = await getBookByIsbn13(isbn13, token?.access)
                setBook(book)
            } catch (err) {
                console.log(err)
            } finally {
                setPending(false)
            }
        })()
    }, [isbn13, token?.access])

    if (pending && !book) {
        return <AppPage name="book">
            <ErrorWrapper>
                <Loader />
            </ErrorWrapper>
        </AppPage>
    }

    if (book == null) {
        return <AppPage name="book">
            <ErrorWrapper>
                <Code>404</Code>
                <Text>This book doesn't exist. Looking for anything specific?</Text>
                <Button onClick={() => history.push('/search')}>Search</Button>
            </ErrorWrapper>
        </AppPage>
    }
    

    // @ts-ignore
    const bg_color = book.bg_color || theme.colors.accent

    return (
        <AppPage name='book' bgColor={bg_color}>
            <Tint />
            <Container>
                <BookInfo book={book}/>
                <ShareFooter>
                    <Button onClick={ () => window && window.open('https://byzans.app.link/book' + location.search) }>{t('app_button')}</Button>
                    <CallToAction> Download Byzans app </CallToAction>
                    <AppStore />
                </ShareFooter>
            </Container>
        </AppPage>
    )
}

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    display: grid;

    justify-items: center;
    align-items: center;

    padding-bottom: 56px;
`

const Tint = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
`

const ShareFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-conetent: center;

    margin: 50px 0;

    ${up('desktop')} {
        display: none;
    }
`

const CallToAction = styled.div`
	margin: 16px 0 16px;

    color: ${p => p.theme.colors.bg};

    font-size: 14px;
	line-height: 24px;
	text-align: center;
`

const ErrorWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 100px;

    display: grid;
    align-items: center;
    justify-items: center;
    grid-row-gap: 30px;
`

const Code = styled.div`
    font-size: 250px;
    font-weight: bold;
    color: ${p => p.theme.colors.accent};
`

const Text = styled.div``



export default BookPage